<template>
    <section class="module-small bg-dark ctaImg">
          <div class="container" style="height: 0px; text-align: center;"> <!-- was 116px; -->
            <div class="row" style="display: inline-block;">
              <div class="col-sm-6 col-md-6 col-lg-6 col-xs-6 button-img-wrap">
                <div >
                 <div class="callout-btn-box bounce_button"><a href="https://press.halfhumangames.com/sheet.php?p=dwerve" class="button"><img v-lazy="imgUrl1" class="button-img" alt=""></a></div>
                </div>
              </div>
              <div class="col-sm-6 col-md-6 col-lg-6 col-xs-6 button-img-wrap">
                <div class="callout-btn-box bounce_button"><a  class="button" href="/faq"><img v-lazy="imgUrl2" class="button-img" alt=""></a></div>
              </div>
            </div>
          </div>
        </section>
</template>

<script>
export default {
  data() {
    return {
      test: false,
      imgUrl1: '/static/assets/images/Dwerve-Pixel-Button-Press.png',
      imgUrl2: '/static/assets/images/Dwerve-Pixel-Button-FAQ.png',
    };
  },
}
</script>


<style scoped>
@import "https://fonts.googleapis.com/css?family=Rubik+One";

.button-img {
  width: 145px;
  -webkit-transform: translatey(0px);
          transform: translatey(0px);
  -webkit-animation: float 8s ease-in-out infinite;
          animation: float 8s ease-in-out infinite;
}
.button::after{
  transform: none;
  background-color: transparent;
}
.button::before{
  transform: none;
  background-color: transparent;
}
.button {
  display: inline-block;
  color: white;
  position: absolute;
  padding: 0;
  top: 50%;
  left: 50%;
  margin-top: -12px;
  transform: translate(-50%, -50%);
  vertical-align: middle;
  font-family: "Rubik One", sans-serif;
  text-decoration: none;
  font-size: 3vw;
  transition: all 0.5s;
  background-color: #3498db00;
}
.col-sm-6.col-md-6.col-lg-6.col-xs-6.button-img-wrap {
    width: 245px;
    margin-left: 50px;
    margin-right: 50px;
}
@font-face {
  font-family: Grandmaster;
  src: url(/static/assets/lib/Grandstander-clean.otf);
}
.cta-title {
  font-family: Grandmaster;
  font-size: 26px;
  text-shadow: -2.4px -2.4px 0 #196090, -2.4px -1.4px 0 #196090,
    -2.4px -0.4px 0 #196090, -2.4px 0.6px 0 #196090, -2.4px 1.6px 0 #196090,
    -2.4px 2.6px 0 #196090, -1.4px -2.4px 0 #196090, -1.4px -1.4px 0 #196090,
    -1.4px -0.4px 0 #196090, -1.4px 0.6px 0 #196090, -1.4px 1.6px 0 #196090,
    -1.4px 2.6px 0 #196090, -0.4px -2.4px 0 #196090, -0.4px -1.4px 0 #196090,
    -0.4px -0.4px 0 #196090, -0.4px 0.6px 0 #196090, -0.4px 1.6px 0 #196090,
    -0.4px 2.6px 0 #196090, 0.6px -2.4px 0 #196090, 0.6px -1.4px 0 #196090,
    0.6px -0.4px 0 #196090, 0.6px 0.6px 0 #196090, 0.6px 1.6px 0 #196090,
    0.6px 2.6px 0 #196090, 1.6px -2.4px 0 #196090, 1.6px -1.4px 0 #196090,
    1.6px -0.4px 0 #196090, 1.6px 0.6px 0 #196090, 1.6px 1.6px 0 #196090,
    1.6px 2.6px 0 #196090, 2.6px -2.4px 0 #196090, 2.6px -1.4px 0 #196090,
    2.6px -0.4px 0 #196090, 2.6px 0.6px 0 #196090, 2.6px 1.6px 0 #196090,
    2.6px 2.6px 0 #196090;
}

.ctaImg {
  background: url(/static/assets/images/Dwerve-Brick-Texture.png);
  padding-top: 48px !important;
  padding: 0;
  height: 190px;
  border-bottom: 9px double #0f0a06;
  border-top: 9px double #0f0a06;
}

.callout-btn-box {
  text-align: right;
  padding-top: 122px;
}
@keyframes bounce {
	0%, 100%, 20%, 50%, 80% {
		-webkit-transform: translateY(0);
		-ms-transform:     translateY(0);
		transform:         translateY(0)
	}
	40% {
		-webkit-transform: translateY(-30px);
		-ms-transform:     translateY(-30px);
		transform:         translateY(-30px)
	}
	60% {
		-webkit-transform: translateY(-15px);
		-ms-transform:     translateY(-15px);
		transform:         translateY(-15px)
	}
}
.bounce_button:hover {
  -webkit-animation: shake 0.5s;
    animation: shake 0.5s;
    -webkit-animation-iteration-count: infinite;
    animation-iteration-count: infinite;
}

@keyframes float {
  0% {
    box-shadow: 0 5px 15px 0px rgba(0, 0, 0, 0.6);
    -webkit-transform: translatey(0px);
            transform: translatey(0px);
  }
  50% {
    box-shadow: 0 25px 15px 0px rgba(0, 0, 0, 0.2);
    -webkit-transform: translatey(-20px);
            transform: translatey(-20px);
  }
  100% {
    box-shadow: 0 5px 15px 0px rgba(0, 0, 0, 0.6);
    -webkit-transform: translatey(0px);
            transform: translatey(0px);
  }
}
@media only screen and (max-width: 950px) {
  .col-sm-6.col-md-6.col-lg-6.col-xs-6.button-img-wrap{
      width: 198px;
      margin-left: 0;
      margin-right: 0;
  }
}

@media only screen and (max-width: 450px) {
  .col-sm-6.col-md-6.col-lg-6.col-xs-6.button-img-wrap{
      width: 158px;
  }
}

</style>


// WEBPACK FOOTER //
// src/views/Home/CTA2.vue